<template>
  <b-row class="container">
    <b-col>
      <b-row>
        <b-col>
          <div class="form-group">
            <label for="value">{{$t("views.agreements.form.advanceValue")}}:</label>
            <input v-model="payment.value" name="value" type="text" required autofocus :placeholder="$t('views.agreements.form.advanceValue')" class="form-control" id="value"/>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="form-group">
            <label>{{$t("views.exsbpaymentsmade.list.invoice")}}:</label>
            <BaseSelectInput
              ref="invoiceInput"
              v-model="payment.idEXSBInvoice"
              :search-callback="invoiceSearchCallback"
              :get-processed-text-custom="getInvoiceProcessedText"
              :display-values="['number', 'buyerName']"
              :query-param="'invoiceAutoCompleteFilter'"
              :placeholder-autocomplete="'Zacznij wpisywać numer lub odbiorcę faktury'"
              :is-auto-complete-mode="true"
            ></BaseSelectInput>
          </div>
        </b-col>
      </b-row>
    </b-col>
    <b-col v-if="invoiceData">
      <transition enter-active-class="animated fadeInDown" leave-active-class="animated fadeOutUp">
        <div>
          <b-container>
            <b><p class="mb-2 p-0 pl-0"><i class="fal fa-file"> </i> <span v-if="getIdLink(invoiceData.invoiceType['@id']) === '1'">{{$t('views.appconfiguration.invoiceConfiguration.vatInvoice')}}</span><span v-else-if="getIdLink(invoiceData.invoiceType['@id']) === '2'">{{$t('views.appconfiguration.invoiceConfiguration.noVatInvoice')}}</span> - {{invoiceData.number}}</p></b>
            <p class="mb-1">{{$t('views.exsbdocument.form.receiver')}}: <b>{{ invoiceData.buyerName }}</b></p>
            <b-row>
              <b-col>
                <p class="mb-1">{{$t('views.exsbinvoices.list.totalValueBrutto')}}: <b>{{ invoiceData.totalValueBrutto }}</b></p>
                <p v-if="invoiceData.invoiceStatus" class="mb-1">{{$t('views.exsbsettlements.show.invoiceStatus')}}:
                  <b v-if="getIdLink(invoiceData.invoiceStatus['@id']) === '1'">{{$t('global.noPayment')}}</b>
                  <b v-if="getIdLink(invoiceData.invoiceStatus['@id']) === '2'">{{$t('global.paymentFull')}}</b>
                  <b v-if="getIdLink(invoiceData.invoiceStatus['@id']) === '3'">{{$t('global.paymentPartial')}}</b>
                </p>
                <p class="mb-1">{{$t('views.exsbinvoices.form.paid')}}: <b>{{ invoiceData.paid }}</b></p>
                <p class="mb-1">{{$t('views.exsbinvoices.form.toPay')}}: <b>{{ invoiceData.toPay }}</b></p>
              </b-col>
              <b-col>
                <p class="mb-1">{{$t('views.exsbinvoices.show.issuePlace')}}: <b>{{ invoiceData.issuePlace }}</b></p>
                <p class="mb-1">{{$t('views.exsbinvoices.list.issueDate')}}: <b>{{ invoiceData.issueDate }}</b></p>
                <p class="mb-1">{{$t('views.exsbinvoices.list.sellDate')}}: <b>{{ invoiceData.sellDate }}</b></p>
                <p class="mb-1">{{$t('views.exsbinvoices.list.paymentDeadline')}}: <b>{{ invoiceData.paymentDeadline }}</b></p>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </transition>
    </b-col>
    <div class="col-lg-12 mt-0 mb-1"><hr></div>
  </b-row>
</template>

<script>
import ApiService from '@/utils/ApiService'
import getId from '@/utils/getIdFromLink'
import BaseSelectInput from '@/components/BaseComponents/BaseSelectInput.vue'

export default {
  name: 'OtherInvoices',
  components: {
    BaseSelectInput
  },
  data () {
    return {
      invoiceData: null,
      display: true,
      disabled: true
    }
  },
  props: {
    removePayment: {
      type: Function,
      required: true
    },
    payment: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  watch: {
    'payment.idEXSBInvoice': function (val) {
      if (val) {
        this.getInvoice(val)
      }
    }
  },
  methods: {
    async invoiceSearchCallback (params = {}) {
      let baseParams = { pagination: false, accepted: 1 }
      Object.assign(baseParams, params)
      const response = await new ApiService('e_x_s_b_invoices', baseParams).getResults()
      return response.items
    },
    async getInvoice (id) {
      this.invoiceData = await new ApiService(id).getResults()
      this.payment.value = this.invoiceData.toPay
      this.invoiceData.issueDate = this.$moment(this.invoiceData.issueDate).format('YYYY-MM-DD')
      this.invoiceData.sellDate = this.$moment(this.invoiceData.sellDate).format('YYYY-MM-DD')
      this.invoiceData.paymentDeadline = this.$moment(this.invoiceData.paymentDeadline).format('YYYY-MM-DD')
      for (let i in this.invoiceData.invoicePosition) {
        if (typeof (this.invoiceData.invoicePosition[i].item) === 'string') {
          this.invoiceData.invoicePosition[i].positionType = 2
        } else if (typeof (this.invoiceData.invoicePosition[i].item) === 'number') {
          this.invoiceData.invoicePosition[i].positionType = 1
        }
      }
    },
    getInvoiceProcessedText (entry) {
      let textData = entry.buyerName + ' / '
      if (entry.nip) {
        textData += entry.nip + ' / '
      }
      textData += entry.number + ' (' + this.$t('views.exsbinvoices.show.toPay') + ': ' + entry.toPay + ' / ' +
        this.$t('views.exsbinvoices.form.invoiceValue') + ': ' + entry.totalValueBrutto + ')'
      return textData
    },
    getIdLink (link) {
      return getId(link)
    }
  }
}
</script>
